import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
//使用vuex插件
Vue.use(Vuex)

export default new Vuex.Store({
  //全局状态
  state: {   //要设置的全局访问的state对象
    //自定义的业务数据
    PcShowConsult: false, //电脑咨询弹出框判断
    mobileShowConsult:false, //手机咨询弹出判断
    isShowNav: false,  //是否显示导航栏
    loginStatus: false,  //登录状态
    count: 0,  //计数
    //行业新闻列表
    MobileCommonQuestionsList: [],
    questionIntroduce: {
    }, //新闻中心问题介绍
    contactIntroduce: {
      personName:'彭海林',
      phoneNumber:'153-8180-0010',
      telephoneNumber:'0576-85286661',
      facsimileNumber:'057685286661',
      email:'804821@qq.com',
      address:'浙江省临海市沙段村1-83号',
      recordNumber:'浙ICP备2024097598号-1',
      policeRecordNumber:' 浙公网安备33108202000840号',
    },
  },
  //同步数据提交,通过mutations改变store存储的数据
  mutations: {
    //state存储数据对象，num为相加或者相减的数据
    addCount(state, num) {
      state.count = state.count + num;
    },
    subCount(state, num) {
      //count为0不能再做减法
      if (state.count > 0) {
        state.count = state.count - num;
      } else {
        state.count = 0;
      }
    }
  },
  //引入持久化组件
  plugins: [
    createPersistedState()
  ],
  //获取值,通过复杂的计算得到数据可以使用getters
  getters: {
    //store里的值发生改变时，getter会返回重新计算的值
    getCount(state, getters) {
      return state.count;
    }
  },
  //异步数据提交
  actions: {}
})



// WEBPACK FOOTER //
// ./src/store/store.js